export const hasValues = (arr: any[]) => {
	return arr && arr.length > 0;
};
